module.exports = __webpack_public_path__ + "public/img/img-placeholder-app-icon@3x.b0237a9d.png";